import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WorkflowStep, WorkflowStepConfiguration, WorkflowStepTypes } from 'src/app/modules/core/store/models/workflow.model';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'topo-workflow-step-edit',
    templateUrl: './workflow-step-edit.component.html',
    styleUrls: ['./workflow-step-edit.component.scss'],
    standalone: false
})
export class WorkflowStepEdit implements OnInit, OnDestroy {
  _step: WorkflowStep;
  isInitialStep: boolean;
  isCompleteStep: boolean;
  isRequired: boolean;
  selectedType: WorkflowStepTypes;
  stepTypes = [
    {
      value: WorkflowStepTypes.Standard,
      name: this.translateService.instant(`MANAGEMENT.WORKFLOW.STEP-TYPE-${WorkflowStepTypes.Standard}`)
    },
    {
      value: WorkflowStepTypes.Approval,
      name: this.translateService.instant(`MANAGEMENT.WORKFLOW.STEP-TYPE-${WorkflowStepTypes.Approval}`)
    },
    {
      value: WorkflowStepTypes.Send,
      name: this.translateService.instant(`MANAGEMENT.WORKFLOW.STEP-TYPE-${WorkflowStepTypes.Send}`)
    },
    {
      value: WorkflowStepTypes.Escalated,
      name: this.translateService.instant(`MANAGEMENT.WORKFLOW.STEP-TYPE-${WorkflowStepTypes.Escalated}`)
    },
    {
      value: WorkflowStepTypes.Complete,
      name: this.translateService.instant(`MANAGEMENT.WORKFLOW.STEP-TYPE-${WorkflowStepTypes.Complete}`)
    },
    {
      value: WorkflowStepTypes.Paused,
      name: this.translateService.instant(`MANAGEMENT.WORKFLOW.STEP-TYPE-${WorkflowStepTypes.Paused}`)
    }
  ];
  @Input() set step(value: WorkflowStep) {
    this._step = cloneDeep(value);
    this.isInitialStep = value?.configuration?.initialStep === true;
    this.isCompleteStep = value?.configuration?.completeStep === true;
    this.isRequired = value?.configuration?.required === true;

    this.selectedType = value?.workflowStepType;
  }
  @Output() save = new EventEmitter<WorkflowStep>();
  @Output() cancel = new EventEmitter<WorkflowStep>();
  @Output() delete = new EventEmitter<WorkflowStep>();

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  initialStepChecked(checkbox: any): void {
    if (!!this._step?.configuration && this._step?.configuration.initialStep !== undefined) {
      this._step.configuration.initialStep = !this._step.configuration.initialStep;
    } else {
      this._step.configuration.initialStep = true;
    }
    this.isInitialStep = this._step?.configuration?.initialStep === true;
  }

  completeStepChecked(checkbox: any): void {
    if (!!this._step?.configuration && this._step?.configuration.completeStep !== undefined) {
      this._step.configuration.completeStep = !this._step.configuration.completeStep;
    } else {
      this._step.configuration.completeStep = true;
    }
    this.isCompleteStep = this._step?.configuration?.completeStep === true;
  }

  saveClick(): void {
    this._step.workflowStepType = this.selectedType;
    this.save.emit(this._step);
  }
  cancelClick(): void {
    this.cancel.emit(this._step);
  }
  deleteClick(): void {
    this.delete.emit(this._step);
  }
}
